import type { Infer } from 'superstruct';
import {
	array,
	nullable,
	number,
	object,
	optional,
	partial,
	string,
} from 'superstruct';

import {
	SalesforceAccount,
	SalesforceLocations,
} from '@adflow/shared/data-salesforce-import';
import {
	parsableBigInt,
	parsableInteger,
	stringDate,
	userString,
} from '@adflow/shared/util-superstruct';

import {
	AddGoogleAdsCampaignLocations,
	ViewGoogleAdsCampaignLocations,
} from './google-ads-campaign-location.dto';

export const ViewGoogleAdsAccountDto = object({
	id: number(),
	name: string(),
	avbId: string(),
	customerId: optional(nullable(parsableBigInt())),
	websiteUrl: optional(nullable(string())),

	salesforceLocations: optional(SalesforceLocations),
	salesforceAccount: optional(SalesforceAccount),
	previousLocations: optional(ViewGoogleAdsCampaignLocations),
	lastAudienceSegmentId: optional(string()),
	lastMerchantCenterId: optional(string()),
	savedPromotionalAssetIds: optional(array(number())),

	syncedAt: stringDate(),
	createdAt: stringDate(),
	updatedAt: stringDate(),
});

export const AddGoogleAdsAccountDto = object({
	id: optional(parsableInteger()),
	avbId: userString('validations:Required'),
	name: optional(string()),
	previousLocations: optional(AddGoogleAdsCampaignLocations),
	lastAudienceSegmentId: optional(string()),
	lastMerchantCenterId: optional(string()),
	savedPromotionalAssetIds: optional(array(number())),
});

export const EditGoogleAdsAccountDto = partial(AddGoogleAdsAccountDto);

export type ViewGoogleAdsAccountDto = Infer<typeof ViewGoogleAdsAccountDto>;
export type AddGoogleAdsAccountDto = Infer<typeof AddGoogleAdsAccountDto>;
export type EditGoogleAdsAccountDto = Infer<typeof EditGoogleAdsAccountDto>;
